import React from 'react';
import './VehicleRegistrationReport.css';

const formatDateVN = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

const VehicleRegistrationReportTable = ({
  data = [],
  page = 1,
  limit = 20,
  user,
  onEdit,
  onDelete
}) => {
  return (
    <div className="vrr-table-responsive">
      <table className="vrr-data-table">
        <thead>
          <tr>
            <th style={{ width: '45px' }}>STT</th>
            <th>Đơn vị</th>
            <th style={{ width: '90px' }}>Ngày</th>
            <th>Số chủ xe rà soát<br />(Biển số xe)</th>
            <th>Xe đang SD<br />chưa sang tên</th>
            <th>Xe đã bán<br />chưa thu hồi</th>
            <th>Yêu cầu<br />sang tên</th>
            <th>Đã hoàn thành<br />sang tên</th>
            <th>Xe hỏng</th>
            <th>Xe mất</th>
            <th>Cập nhật<br />hệ thống</th>
            <th>Chuyển TTKS/<br />XLVP/ĐTGQTN</th>
            <th>DS nhận từ TTKS/<br />XLVP/ĐTGQTN</th>
            <th>Ghi chú</th>
            <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="15" style={{ textAlign: 'center', padding: '30px', color: '#64748b' }}>
                Không có dữ liệu báo cáo nào
              </td>
            </tr>
          ) : (
            data.map((item, index) => {
              const canEdit = user?.role === 'admin' || user?.role === 'supervisor' || item.unitId === user?.unitId;
              return (
                <tr key={item.id}>
                  <td style={{ textAlign: 'center' }}>{(page - 1) * limit + index + 1}</td>
                  <td>{item.unit?.name || '—'}</td>
                  <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                    {formatDateVN(item.reportDate)}
                  </td>
                  <td className="vrr-plate-cell">{item.licensePlate}</td>
                  <td style={{ textAlign: 'center' }}>
                    {item.inUseNotTransferred ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {item.soldNotRevoked ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {item.transferRequested ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {item.transferCompleted ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {item.broken ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {item.lost ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {item.systemUpdated ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {item.transferredToInspection ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {item.receivedFromInspection ? <span className="vrr-status-check">✅</span> : <span className="vrr-status-empty">—</span>}
                  </td>
                  <td style={{ maxWidth: '180px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.notes || ''}>
                    {item.notes || '—'}
                  </td>
                  <td>
                    {canEdit ? (
                      <div className="vrr-action-cell">
                        <button
                          className="vrr-btn-edit"
                          onClick={() => onEdit(item)}
                          title="Sửa bản ghi"
                        >
                          Sửa
                        </button>
                        <button
                          className="vrr-btn-delete"
                          onClick={() => onDelete(item.id)}
                          title="Xóa bản ghi"
                        >
                          Xóa
                        </button>
                      </div>
                    ) : (
                      <span style={{ color: '#94a3b8', fontSize: '12px', textAlign: 'center', display: 'block' }}>Chỉ xem</span>
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default VehicleRegistrationReportTable;
